(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mad-lemon-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function rotateFlowers() {
      var flowers = document.querySelectorAll('.js-ml-scroll-flower');
      if (!flowers.length) return;

      var rotation = window.scrollY * 0.18;

      flowers.forEach(function(flower) {
        flower.style.transform = 'rotate(' + rotation + 'deg)';
      });
    }

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          rotateFlowers();
          ticking = false;
        });

        ticking = true;
      }
    }

    rotateFlowers();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mad-lemon-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('.ml-header__toggle');
    if (!toggle) return;

    var header = toggle.closest('.ml-header');
    var isOpen = header.classList.toggle('is-open');

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mad-lemon-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('.ml-pdp__thumb');

    if (thumb) {
      var root = thumb.closest('.ml-pdp');
      var index = thumb.getAttribute('data-media-index');

      root
        .querySelectorAll('.ml-pdp__thumb, .ml-pdp__media-item')
        .forEach(function(item) {
          item.classList.toggle(
            'is-active',
            item.getAttribute('data-media-index') === index
          );
        });
    }

    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');

    if (minus || plus) {
      var qty = event.target
        .closest('.ml-pdp__qty')
        .querySelector('input');

      var value = parseInt(qty.value || '1', 10);

      qty.value = minus
        ? Math.max(1, value - 1)
        : value + 1;
    }
  });

  document.addEventListener('change', function(event) {
    var input = event.target.closest('.ml-pdp__option-values input');

    if (!input) return;

    var form = input.closest('.ml-pdp__form');
    var summary = form.closest('.ml-pdp__summary');
    var variantsScript = form.querySelector('[data-variants-json]');
    var idInput = form.querySelector('[data-variant-id-input]');
    var price = summary.querySelector('[data-price]');
    var addButton = form.querySelector('[data-add-button]');

    if (!variantsScript || !idInput) return;

    var variants = JSON.parse(variantsScript.textContent);
    var selectedOptions = [];

    form
      .querySelectorAll('.ml-pdp__option')
      .forEach(function(fieldset) {
        var checked = fieldset.querySelector('input:checked');

        if (checked) {
          selectedOptions.push(checked.value);
        }
      });

    var selectedVariant = variants.find(function(variant) {
      return (
        variant.options.length === selectedOptions.length &&
        variant.options.every(function(option, index) {
          return option === selectedOptions[index];
        })
      );
    });

    if (!selectedVariant) return;

    idInput.value = selectedVariant.id;

    if (price) {
      price.textContent = selectedVariant.price;
    }

    if (addButton) {
      addButton.disabled = !selectedVariant.available;

      addButton.textContent = selectedVariant.available
        ? addButton.dataset.availableText
        : addButton.dataset.soldOutText;
    }
  });

  (function() {
    function rotateFlowers() {
      var flowers = document.querySelectorAll(
        '.js-ml-pdp-flower'
      );

      if (!flowers.length) return;

      var rotation = window.scrollY * 0.18;

      flowers.forEach(function(flower) {
        flower.style.transform =
          'rotate(' + rotation + 'deg)';
      });
    }

    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          rotateFlowers();
          ticking = false;
        });

        ticking = true;
      }
    }

    rotateFlowers();

    window.addEventListener('scroll', onScroll, {
      passive: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function() {
    var cart = document.querySelector('[data-ml-main-cart]');
    if (!cart) return;

    function updateLine(line, quantity) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: Number(line),
          quantity: Number(quantity)
        })
      }).then(function() {
        window.location.reload();
      });
    }

    cart.addEventListener('click', function(event) {
      var item = event.target.closest('.ml-main-cart-item');
      if (!item) return;

      var line = item.getAttribute('data-line');
      var input = item.querySelector('[data-ml-cart-qty]');
      var current = parseInt(input.value || '1', 10);

      if (event.target.closest('[data-ml-cart-minus]')) {
        updateLine(line, Math.max(0, current - 1));
      }

      if (event.target.closest('[data-ml-cart-plus]')) {
        updateLine(line, current + 1);
      }

      if (event.target.closest('[data-ml-cart-remove]')) {
        updateLine(line, 0);
      }
    });

    cart.addEventListener('change', function(event) {
      var input = event.target.closest('[data-ml-cart-qty]');
      if (!input) return;

      var item = input.closest('.ml-main-cart-item');
      var line = item.getAttribute('data-line');
      var quantity = Math.max(0, parseInt(input.value || '0', 10));

      updateLine(line, quantity);
    });

    function rotateFlowers() {
      var flowers = document.querySelectorAll('.js-ml-cart-flower');
      if (!flowers.length) return;

      var rotation = window.scrollY * 0.18;

      flowers.forEach(function(flower) {
        flower.style.transform = 'rotate(' + rotation + 'deg)';
      });
    }

    var ticking = false;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          rotateFlowers();
          ticking = false;
        });

        ticking = true;
      }
    }, { passive: true });

    rotateFlowers();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-floating-cart"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-ml-cart-root]');
    if (!root) return;

    var drawer = root.querySelector('[data-ml-cart-drawer]');
    var openButtons = root.querySelectorAll('[data-ml-cart-open]');
    var closeButtons = root.querySelectorAll('[data-ml-cart-close]');
    var countEl = root.querySelector('[data-ml-cart-count]');
    var itemsEl = root.querySelector('[data-ml-cart-items]');
    var subtotalEl = root.querySelector('[data-ml-cart-subtotal]');
    var routesRoot = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    function escapeHTML(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }

      return '$' + (cents / 100).toFixed(2);
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function renderCart(cart) {
      countEl.textContent = cart.item_count;
      subtotalEl.textContent = formatMoney(cart.total_price);

      if (!cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<p class="ml-cart-drawer__empty">Your cart is empty.</p>';
        return;
      }

      itemsEl.innerHTML = cart.items.map(function(item) {
        var image = item.image
          ? '<span class="ml-cart-item__image"><img src="' + escapeHTML(item.image) + '" alt="' + escapeHTML(item.product_title) + '"></span>'
          : '<span class="ml-cart-item__image"></span>';

        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="ml-cart-item__variant">' + escapeHTML(item.variant_title) + '</p>'
          : '';

        return (
          '<article class="ml-cart-item">' +
            image +
            '<div>' +
              '<h3 class="ml-cart-item__title">' + escapeHTML(item.product_title) + '</h3>' +
              variant +
              '<div class="ml-cart-item__controls">' +
                '<div class="ml-cart-item__qty" aria-label="Quantity controls">' +
                  '<button type="button" aria-label="Decrease quantity" data-ml-cart-decrease data-key="' + escapeHTML(item.key) + '" data-quantity="' + item.quantity + '">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" aria-label="Increase quantity" data-ml-cart-increase data-key="' + escapeHTML(item.key) + '" data-quantity="' + item.quantity + '">+</button>' +
                '</div>' +
                '<button type="button" class="ml-cart-item__remove" data-ml-cart-remove data-key="' + escapeHTML(item.key) + '">Remove</button>' +
              '</div>' +
              '<p class="ml-cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
            '</div>' +
          '</article>'
        );
      }).join('');
    }

    function refreshCart(openAfter) {
      return fetch(routesRoot + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          renderCart(cart);
          if (openAfter) openDrawer();
          return cart;
        });
    }

    function changeCartItem(key, quantity) {
      root.classList.add('is-updating');

      return fetch(routesRoot + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart change failed');
          return response.json();
        })
        .then(function(cart) {
          renderCart(cart);
          openDrawer();
        })
        .finally(function() {
          root.classList.remove('is-updating');
        });
    }

    openButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        refreshCart(true);
      });
    });

    closeButtons.forEach(function(button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('click', function(event) {
      var increase = event.target.closest('[data-ml-cart-increase]');
      var decrease = event.target.closest('[data-ml-cart-decrease]');
      var remove = event.target.closest('[data-ml-cart-remove]');

      if (increase) {
        changeCartItem(increase.dataset.key, parseInt(increase.dataset.quantity || '0', 10) + 1);
      }

      if (decrease) {
        changeCartItem(decrease.dataset.key, Math.max(0, parseInt(decrease.dataset.quantity || '1', 10) - 1));
      }

      if (remove) {
        changeCartItem(remove.dataset.key, 0);
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') closeDrawer();
    });

    document.addEventListener('submit', function(event) {
      var form = event.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      var submitter = event.submitter;
      if (submitter && submitter.name !== 'add') return;

      event.preventDefault();

      var formData = new FormData(form);

      fetch(routesRoot + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function() {
          return refreshCart(true);
        })
        .catch(function() {
          form.submit();
        });
    });

    refreshCart(false);
  })();

  } catch(e) { console.error(e); }
})();
})();
